import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const s = useSettings();
  const phone = s.phone_primary || "9513951318";
  const phone2 = s.phone_secondary || "9892989269";
  return (
    <footer className="bg-[#0F172A] text-slate-300 mt-auto" data-testid="site-footer">
      <div className="container-x py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            {s.logo ? <div className="bg-white rounded-md p-1.5"><img src={s.logo} alt="REXTECH" className="h-10 w-auto object-contain"/></div>
              : <div className="w-10 h-10 bg-[#EA580C] rounded-md flex items-center justify-center font-heading font-extrabold text-white">RX</div>}
            <div><div className="font-heading font-extrabold text-white">REXTECH</div><div className="text-[10px] tracking-widest">IT SOLUTIONS</div></div>
          </div>
          <p className="text-sm">{s.tagline || "Your Trusted IT Technology Partner"}</p>
          <p className="text-sm mt-2 text-slate-400">{s.secondary_line || "Solve | Support | Succeed"}</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Products</h4>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/products?category=Laptops" className="hover:text-white">Laptops</Link></li>
            <li><Link to="/products?category=Desktops" className="hover:text-white">Desktops</Link></li>
            <li><Link to="/products?category=Computer%20Parts" className="hover:text-white">Computer Parts</Link></li>
            <li><Link to="/products" className="hover:text-white">Accessories</Link></li>
            <li><Link to="/products" className="hover:text-white">Storage</Link></li>
            <li><Link to="/products" className="hover:text-white">Networking</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Business</h4>
          <ul className="space-y-1.5 text-sm">
            <li><Link to="/wholesale" className="hover:text-white">Wholesale</Link></li>
            <li><Link to="/dealers" className="hover:text-white">Dealers & Resellers</Link></li>
            <li><Link to="/corporate" className="hover:text-white">Corporate Supply</Link></li>
            <li><Link to="/request-quote" className="hover:text-white">Request Quote</Link></li>
            <li><Link to="/price-list" className="hover:text-white" data-testid="footer-price-list">Wholesale Price List</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5"/><span>{phone}<br/>{phone2}</span></li>
            <li className="flex items-start gap-2"><MessageCircle className="w-4 h-4 mt-0.5 text-[#25D366]"/><a href={`https://wa.me/91${phone}`}>{phone}</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5"/>{s.email || "rextechitsolutions@gmail.com"}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5"/>{s.address || "Bengaluru, Karnataka"}</li>
            <li className="flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5"/>{s.business_hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-4 flex flex-wrap items-center justify-between gap-2 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} REXTECH IT SOLUTION. All rights reserved.</div>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
            <Link to="/shipping" className="hover:text-white">Shipping / Order Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
